/* eslint-disable max-len */
import { SvgProps } from './types'

export const DollarShinyIcon = ({ color, className }: SvgProps) => {
  let drawColor = color
  if (drawColor === 'blue') {
    drawColor = '#00BFFF'
  } else if (drawColor === 'pink') {
    drawColor = '#CC00A1'
  }

  return (
    <svg 
      width="33" 
      height="30" 
      viewBox="0 0 33 30" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_297_20165)">
        <path d="M29.3021 23.2048L26.7559 21.5455" stroke={drawColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M29.3021 6.79523L26.7559 8.45138" stroke={drawColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M31.6372 14.955H28.3652" stroke={drawColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M3.32422 23.2048L5.87047 21.5455" stroke={drawColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M3.32422 6.79523L5.86737 8.45138" stroke={drawColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M0.989258 14.955H4.26124" stroke={drawColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M17.145 12.8213C13.7738 11.4318 13.7582 10.3991 13.752 9.90284C13.7396 9.20193 14.3444 8.01719 16.0068 7.8094C16.5464 7.74117 17.1791 7.76908 17.8366 7.89003C18.9717 8.09473 20.0417 9.09338 20.0417 9.72296H23.7665C23.7665 6.91619 21.031 4.68628 18.5003 4.22728C18.3979 4.20867 18.2987 4.19316 18.1964 4.17765V0.98941H14.4716V4.33272C11.5345 5.1639 9.99314 7.72256 10.0273 9.96177C10.0831 13.4881 13.1007 15.1814 15.7245 16.2638C20.0789 18.0595 19.8122 19.4614 19.6695 20.215C19.4555 21.3408 18.3483 22.0324 16.6301 22.1131C16.168 22.1348 15.6687 22.0914 15.1508 21.9859C14.1614 21.7843 12.5146 21.102 12.5859 18.7946L8.86423 18.6798C8.75568 22.1968 10.9329 24.926 14.4095 25.6332C14.4313 25.6363 14.4499 25.6394 14.4716 25.6456V29.0106H18.1964V25.6673C21.4063 25.047 22.957 22.8884 23.3323 20.9035C24.2007 16.3041 20.2185 14.0866 17.1481 12.8213H17.145Z" stroke={drawColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_297_20165">
          <rect width="32.8846" height="30" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  )
}
